<template>
  <v-container fluid>
    <v-row justify="center" align="center" fluid class="pt-6 pb-6">
      <p
        class="display-2 text-center font-weight-bold indigo--text"
      >The only virus present is your racism</p>
    </v-row>
    <v-row class="amber lighten-4" fluid pt-0 pb-0 pl-0 pr-0>
      <v-col cols="8" class="pa-2" align="center">
        <v-img style="width:80%" src="@/assets/VA/Photography/Xiao_Ma/1.jpg"></v-img>
        <v-img style="width:80%" src="@/assets/VA/Photography/Xiao_Ma/2.jpg"></v-img>
        <v-img style="width:80%" src="@/assets/VA/Photography/Xiao_Ma/3.jpg"></v-img>
        <v-img style="width:80%" src="@/assets/VA/Photography/Xiao_Ma/4.jpg"></v-img>
        <v-img style="width:80%" src="@/assets/VA/Photography/Xiao_Ma/5.jpg"></v-img>
        <v-img style="width:80%" src="@/assets/VA/Photography/Xiao_Ma/6.jpg"></v-img>

        <v-container style="width:80%">
          <p class="text-sm-center font-weight-bold">Artist Statement</p>
          <p
            class="text-sm-left"
          >This work expresses my feelings to xenophobia relating to the corona virus. I finished this work in the beginning of march, when virus starting to hit the United States. Hostility behaviors towards other people because of their racial identity can tear our humanity apart. Being racially Asian, I was hurt and attacked by some strangers and some people around me. Emotions gathered and inspired me to create this project. I want to express the importance to love and care for each other at this unexpected time, and the lack of attention we are giving to the world as global citizens.</p>
        </v-container>
      </v-col>
      <v-col cols="4">
        <AUTH :author="author" />
        <p class="text-sm-left">{{author.bio}}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AUTH from "../../../Article/Author.vue";
export default {
  props: ["author"],
  components: {
    AUTH
  }
};
</script>